import React, { useEffect, useState } from 'react';
import Axios from 'axios';
import './Jobs.scss';
import './mediaQuery.scss';
import Dialog from './../../components/Dialog/Dialog';
import JobDesc from './../../components/JobDesc/JobDesc';
import { setWechatShare } from '../../utils';
interface Props {
  getPath: (path: string) => void;
}

const Jobs: React.FC<Props> = props => {
  const [visible, setVisible] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [jobList, setJobList] = useState([]);
  const [isWeixin, setIsWeixin] = useState(false);

  const isWeixinBrowser = () => {
    const ua = window.navigator.userAgent.toLowerCase();
    return ua.indexOf('micromessenger') !== -1;
  };

  const setData = async () => {
    const res = await Axios.get(
      'http://ar.lanxiongtiyu.com/lxPay/lanxiong/getPositionInfoList'
    );
    const { data } = res.data;
    if (data) {
      setJobList(data);
    }
  };

  useEffect(() => {
    props.getPath('/jobs');

    const title = '加入我们-懒熊体育-让体育产业高效连接';

    document.title = title;
    setIsWeixin(isWeixinBrowser());
    setWechatShare({
      title,
    });
    setData();
  }, [props]);

  return (
    <>
      <div className="Jobs">
        <div className="mask"></div>
        <section className="video-wrapper">
          <video
            className="video"
            id="video"
            src="http://videocdn.lanxiongsports.com/lanxiong_hr.mp4"
            poster="http://imgcdn.lanxiongsports.com/lanxiong_vid_bg.jpg"
            autoPlay
            muted
            loop
            playsInline={true}
            webkit-playsinline="true"
            x5-playsinline="true"
            x5-video-player-type="h5-page"
            controls={isWeixin}
            preload="auto"
          ></video>
        </section>
        <section className="jobs-content">
          <h1>懒熊体育，期待你的加入！</h1>
          
          <ul className="job-list">
            {(jobList as Array<{
              name: string;
              department: string;
              city: string;
              responsibilities: string;
              requirements: string;
              link: string;
            }>).map((item, index) => (
              <li
                key={index}
                onClick={() => {
                  setActiveIndex(index);
                  setVisible(true);
                  document.body.classList.add('fix');
                }}
              >
                <h4>{item.name}</h4>
                <p>
                  {item.department} · {item.city}
                </p>
              </li>
            ))}
          </ul>
          <p className="email">简历请投递至：HR@lanxiongsports.com</p>
        </section>
      </div>
      <Dialog
        Content={() => <JobDesc {...jobList[activeIndex]} />}
        visible={visible}
        onCancel={() => {
          document.body.classList.remove('fix');
          setVisible(false);
        }}
      />
    </>
  );
};

export default Jobs;
